import CONSTANTS from 'constants/state';
import actions from '../actions/ui';
import cookieUtil from '../../utils/cookie';
import { DEFAULT_COOKIES } from '../../constants/cookies';
import { logger } from 'packages';

const getItemLayoutCookie = () => {
    const val = cookieUtil.readCookie(DEFAULT_COOKIES['ITEM_LAYOUT'].key);
    return val || DEFAULT_COOKIES['ITEM_LAYOUT'].default;
};

export const defaultState = {
    quickView: {
        open: CONSTANTS.MODAL.CLOSED,
        items: {},
        itemIds: [],
        currentItem: 0
    },
    videoModal: {
        open: CONSTANTS.MODAL.CLOSED,
        video: ''
    },
    signInModal: {
        open: CONSTANTS.MODAL.CLOSED,
        redirectUrl: false
    },
    megaMenu: {
        open: CONSTANTS.MENU.CLOSED,
        selected: 0
    },
    messagingModal: {
        open: CONSTANTS.MODAL.CLOSED,
        title: '',
        src: '',
        participating: false,
        recipientId: '',
        item: null
    },
    itemLayout: getItemLayoutCookie(),
    badges: {
        messaging: {
            threads: 0,
            threadsUnread: 0,
            lastFetched: 0
        }
    }
};

export default (state = defaultState, action) => {
    const openQuickView = () => {
        const {
            itemIds = state.quickView.itemIds,
            itemId = state.quickView.itemId
        } = action.payload;
        return {
            ...state,
            quickView: {
                ...state.quickView,
                open: CONSTANTS.MODAL.OPEN,
                itemIds: itemIds,
                currentItem: itemId
            }
        };
    };

    const closeQuickView = () => {
        return {
            ...state,
            quickView: {
                ...state.quickView,
                open: CONSTANTS.MODAL.CLOSED
            }
        };
    };

    const openVideoModal = () => {
        const { videoId, title, pageType } = action.payload;
        return {
            ...state,
            videoModal: {
                ...state.videoModal,
                open: CONSTANTS.MODAL.OPEN,
                videoId: videoId,
                title: title,
                pageType: pageType
            }
        };
    };

    const closeVideoModal = () => {
        return {
            ...state,
            videoModal: {
                ...state.videoModal,
                open: CONSTANTS.MODAL.CLOSED
            }
        };
    };

    const openMegaMenu = () => ({
        ...state,
        megaMenu: {
            open: CONSTANTS.MENU.OPEN,
            selected: action.payload
        }
    });

    const closeMegaMenu = () => {
        return {
            ...state,
            megaMenu: {
                open: CONSTANTS.MENU.CLOSED
            }
        };
    };

    const openSignInModal = () => {
        const { payload = {} } = action;
        return {
            ...state,
            signInModal: {
                open: CONSTANTS.MODAL.OPEN,
                redirectUrl: payload.redirectUrl
            }
        };
    };

    const closeSignInModal = () => {
        return {
            ...state,
            signInModal: {
                open: CONSTANTS.MODAL.CLOSED
            }
        };
    };

    /*
        Changes made to messaging modal will affect My Tradera as well!
        TODO - test this!
    */
    const openMessagingModal = () => {
        const {
            title = state.messagingModal.title,
            src = state.messagingModal.src,
            participating = state.messagingModal.participating,
            recipientId = state.messagingModal.recipientId,
            item = state.messagingModal.item
        } = action.payload;
        return {
            ...state,
            messagingModal: {
                open: CONSTANTS.MODAL.OPEN,
                title: title,
                src: src,
                participating: participating,
                recipientId: recipientId,
                item: item
            }
        };
    };

    const closeMessagingModal = () => {
        return {
            ...state,
            messagingModal: {
                open: CONSTANTS.MODAL.CLOSED
            }
        };
    };

    const itemLayout = () => {
        let def = DEFAULT_COOKIES[action.payload.name];
        const expires = new Date();
        expires.setMonth(expires.getMonth() * def.length);
        try {
            cookieUtil.createCookie(def.key, action.payload.value, expires);
        } catch (e) {
            logger(e);
        }
        if (state['itemLayout'] === action.payload.value) {
            return state;
        }
        return {
            ...state,
            ['itemLayout']: action.payload.value
        };
    };

    const updateMessagingNotificatoins = () => ({
        ...state,
        badges: {
            messaging: action.payload
        }
    });

    const def = () => state;

    const reducers = {
        [actions.actionTypes.OPEN_QUICK_VIEW]: openQuickView,
        [actions.actionTypes.CLOSE_QUICK_VIEW]: closeQuickView,
        [actions.actionTypes.OPEN_VIDEO_MODAL]: openVideoModal,
        [actions.actionTypes.CLOSE_VIDEO_MODAL]: closeVideoModal,
        [actions.actionTypes.OPEN_MEGA_MENU]: openMegaMenu,
        [actions.actionTypes.CLOSE_MEGA_MENU]: closeMegaMenu,
        [actions.actionTypes.OPEN_SIGN_IN_MODAL]: openSignInModal,
        [actions.actionTypes.CLOSE_SIGN_IN_MODAL]: closeSignInModal,
        [actions.actionTypes.OPEN_MESSAGING_MODAL]: openMessagingModal,
        [actions.actionTypes.CLOSE_MESSAGING_MODAL]: closeMessagingModal,
        [actions.actionTypes.ITEM_LAYOUT]: itemLayout,
        [actions.actionTypes
            .UPDATE_MESSAGING_NOTIFICATIONS]: updateMessagingNotificatoins
    };

    return !action || !action.type || !reducers[action.type]
        ? def()
        : reducers[action.type]();
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/reducers/ui.js